import React from 'react';
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';

export interface DateIconProps {
  date: string | Date;
}

const DateIcon: React.FC<DateIconProps> = ({ date }) => {
  const isToday = new Date().toDateString() === new Date(date).toDateString();

  return isToday ? <ClockCircleOutlined /> : <CalendarOutlined />;
};

export default DateIcon;
